import { Button } from "@loot-os/ui/components/button";
import { Card, CardContent } from "@loot-os/ui/components/card";
import { Skeleton } from "@loot-os/ui/components/skeleton";
import { useQuery } from "@tanstack/react-query";
import { type ReactNode, useState } from "react";

import { lootMeQueryOptions } from "../../lib/queries.js";
import { useShopper } from "../../lib/shopper.js";
import { useTerminology } from "../../lib/terminology.js";
import { UsernameDialog } from "../UsernameDialog.js";

/**
 * Forging names the creator on every box, so the builder asks for a username before the shopper
 * fills it in, as the chat does before a first message. The server refuses a write without one
 * (`username_required`) either way; this only saves filling in the form first.
 */
export function ForgeUsernameGate({ children }: { children: ReactNode }) {
  const { sessionToken } = useShopper();
  const { box } = useTerminology();
  const me = useQuery({ ...lootMeQueryOptions(), enabled: !!sessionToken });
  const [open, setOpen] = useState(false);

  if (!sessionToken || me.isPending) return <Skeleton className="h-40 rounded-xl" />;
  // A failed read falls through to the builder: the server still checks.
  if (me.data && !me.data.username) {
    return (
      <Card>
        <CardContent className="grid justify-items-start gap-3">
          <p className="text-sm">
            Every {box.singular} you forge shows your username as its creator. Choose one first.
          </p>
          <Button onClick={() => setOpen(true)}>Choose a username</Button>
          {open && <UsernameDialog open={open} onOpenChange={setOpen} username={null} />}
        </CardContent>
      </Card>
    );
  }
  return <>{children}</>;
}
